import ParachuteContainer from 'components/Game/Parachute/ParachuteContainer'
import ParachutePresentation from 'components/Game/Parachute/ParachutePresentation'
import ParachuteData from 'components/Game/Parachute/ParachuteData'

export default {
  Container: ParachuteContainer,
  Presentation: ParachutePresentation,
  Data: ParachuteData,
}
